import { render, staticRenderFns } from "./HistoryDemo.vue?vue&type=template&id=fc9b5ef8&scoped=true&"
import script from "./HistoryDemo.vue?vue&type=script&lang=js&"
export * from "./HistoryDemo.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDemo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HistoryDemo.vue?vue&type=style&index=1&id=fc9b5ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9b5ef8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDialog,VList,VListItem,VListItemContent,VMenu,VProgressLinear,VRow})
